module.exports = __webpack_public_path__ + "img/total.a9e22d70.png";